module.exports = __webpack_public_path__ + "img/aptamil-2plus-1200g.4ad6638d.png";